export class Config {
    public id: string;
    public name: string;
    public titleHtml: string;
    public authApiAudience: string;
    public authCallbackUrl: string;
    public authClientConnection: string;
    public authPrimaryConnection: string;
    public authClientId: string;
    public authClientDomain: string;
    public applicationInsightsKey: string;
    public productsApiBaseAddress: string;
    public instrumentationKey: string;
}



// WEBPACK FOOTER //
// D:/a/1/s/src/app/entities/config.ts